import { useEffect, useRef, useState } from "react";
import volume from '../../../../assets/patientcharts/Player Volume.png'
import play from '../../../../assets/cards/Vector.svg'
import roundmusic from '../../../../assets/cards/Play.svg'
import waveform from '../../../../assets/patientcharts/Waveform.png'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { formatDdmmyyyy, formatDdmmyyyyy } from "../../../../utils/dateutils/dateutility";
import pause from '../../../../assets/audio/Pause.png';
import { DateTime } from 'luxon';
import blinkscribeapi from "../../../../api/blinkscribeapi";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeHigh, faVolumeXmark } from '@fortawesome/free-solid-svg-icons';
import Percentagering from "./Percentagering";
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import TaskIcon from '@mui/icons-material/Task';
export const AudioCardGrid = ({card,handlepdf, setEditCard, setIsEditScreen,searchDate,handleplay,audioSrc,setSelectedCard,selectedCard,setAudioSrc,fetchimg,data}) => {
  const [percentage, setPercentage] = useState(20);
  const circleStyle = {
    background: `conic-gradient(#7E7E7E ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };
  const [showloader,setShowLoader]=useState(false)
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [ismuted,setIsmuted]=useState(false)
  const audioRef = useRef(null);
  const isallow=useRef()
const [isFirsttime,setISfirsttime]=useState(false)
const cardRef=useRef()
const navigate=useNavigate()
const handlePlayPause = () => {
  if(!audioSrc){
  
    return
  }
  if (isPlaying) {
      audioRef.current.pause();
  } else {
      audioRef.current.play();
  }
  setIsPlaying(!isPlaying);
};
const handleTimeUpdate = () => {
setCurrentTime(audioRef.current.currentTime);
};

const handleLoadedMetadata = () => {
setDuration(audioRef.current.duration);
};

const handleSeek = (e) => {
const newTime = (e.target.value * duration) / 100;
audioRef.current.currentTime = newTime;
setCurrentTime(newTime);
};

useEffect(()=>{
if(audioSrc&&!isFirsttime&&isallow.current){
handlePlayPause()
setISfirsttime(true)
}
},[audioSrc])
useEffect(() => {
const handleClickOutside = (event) => {
  if (cardRef.current && !cardRef.current.contains(event.target)) {
  isallow.current=false
    setIsPlaying(false);
    if (audioRef.current) {
  
      audioRef.current.currentTime = 0;
    }
  }
};

document.addEventListener('mousedown', handleClickOutside);
return () => {
  document.removeEventListener('mousedown', handleClickOutside);
};
}, []);
const toggleMute = () => {
setIsmuted(!ismuted);
if (audioRef.current) {
    audioRef.current.muted = !ismuted;
}
};

const renderStatus = (item) => {

  // Render progress or status based on transcription status
  if (item.transcriptionstatus === null || item.transcriptionstatus === "") {
    return "Ready";
  } else if (item.transcriptionstatus === "Submitted") {
    return <Percentagering percentage={20} />;
  } else if (item.transcriptionstatus === "Processing") {
    const recording_duration = item.recording_duration || 200; // Fallback to a default value
    const totalProcessingTime = Math.max((420 / 1287) * recording_duration, 60);
    const recordingStartTime = DateTime.fromISO(item.ts).toSeconds();
// Current time in UTC, rounded to whole seconds
   const currentTime = Math.floor(DateTime.now().toSeconds()); // or you can use Math.round() if you prefer rounding

    const elapsedSinceStart = Math.max(currentTime - recordingStartTime, 0);

    // Calculate the initial percentage based on the elapsed time
    const completionPercentage = Math.min(
      Math.round(20 + (70 * elapsedSinceStart) / totalProcessingTime),
      90
    );

return <Percentagering percentage={completionPercentage} />;

  } else if (item.transcriptionstatus === "Summarized") {
 
    return (
      <div className="ml-2" onClick={(e)=>{
        e.stopPropagation()
//    setEditCard(card)
// setIsEditScreen(true)
      }}>
        <Tooltip title="Pending Review">
          {/* <img src={summarizedpng} alt="pending review" className="w-6 h-6" /> */}
          {/* <PlagiarismIcon className="text-[green]"/> */}
          <Percentagering percentage={100} />
        </Tooltip>
      </div>
    );
  } else if (item.transcriptionstatus === "APPROVED") {
    return (
      <div className="ml-2">
        <Tooltip title="Completed">
          {/* <img src={checkmark} alt="Completed" className="w-6 h-6" /> */}
          <TaskIcon className="text-[green]"/>
        </Tooltip>
      </div>
    );
  } else {
    return null;
  }
}


  return (
    <>
      <div className="w-[383px] h-[164px] flex flex-col items-start justify-between p-6 bg-white rounded-[15px] shadow-md border-t-2 border-[#1d2951]">
        <div className=" w-full flex  justify-between items-center gap-2">
          <div className=" font-inter text-center text-[#141515] text-[17px] font-medium tracking-[0] leading-[normal] whitespace-nowrap">
       {formatDdmmyyyyy(card?.ts)}
          </div>
          <div className="flex  items-center gap-2">
            <div className={`${card.transcriptionstatus !== "Summarized"?"cursor-not-allowed":"cursor-pointer"}`} onClick={()=>{
                         if(card.transcriptionstatus !== "Summarized"){
  return
}       // navigate(`/archive-edit/${card?.id}/${card?.patient_name}`)
   setEditCard(card)
setIsEditScreen(true)
            }}>
     <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
            >
              <path
                d="M18.5333 6.08429L20.916 8.46592M20.0655 3.98617L13.6226 10.429C13.2897 10.7615 13.0627 11.185 12.9701 11.6463L12.375 14.6253L15.354 14.029C15.8152 13.9368 16.2382 13.7107 16.5712 13.3777L23.0141 6.93479C23.2077 6.74118 23.3613 6.51134 23.4661 6.25837C23.5709 6.00541 23.6248 5.73429 23.6248 5.46048C23.6248 5.18668 23.5709 4.91555 23.4661 4.66259C23.3613 4.40963 23.2077 4.17978 23.0141 3.98617C22.8205 3.79256 22.5907 3.63898 22.3377 3.5342C22.0847 3.42942 21.8136 3.37549 21.5398 3.37549C21.266 3.37549 20.9949 3.42942 20.7419 3.5342C20.489 3.63898 20.2591 3.79256 20.0655 3.98617V3.98617Z"
                stroke="#7E7E7E"
                stroke-width="2.56214"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21.3755 16.875V20.25C21.3755 20.8467 21.1384 21.419 20.7165 21.841C20.2945 22.2629 19.7222 22.5 19.1255 22.5H6.75049C6.15375 22.5 5.58145 22.2629 5.1595 21.841C4.73754 21.419 4.50049 20.8467 4.50049 20.25V7.875C4.50049 7.27826 4.73754 6.70597 5.1595 6.28401C5.58145 5.86205 6.15375 5.625 6.75049 5.625H10.1255"
                stroke="#7E7E7E"
                stroke-width="2.56214"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            </div>
       
            <div  className={`${!["Summarized","APPROVED"].includes(card.transcriptionstatus)?"cursor-not-allowed":"cursor-pointer"}`} onClick={()=>{
                      if(!["Summarized","APPROVED"].includes(card.transcriptionstatus)){
  return
}
      fetchimg(card.audiolink.split(".")[0],card)    
            }}>

 <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M7.02 25C6.44417 25 5.96375 24.8075 5.57875 24.4225C5.19375 24.0375 5.00083 23.5567 5 22.98V7.02C5 6.44417 5.19292 5.96375 5.57875 5.57875C5.96458 5.19375 6.445 5.00083 7.02 5H22.9813C23.5562 5 24.0367 5.19292 24.4225 5.57875C24.8083 5.96458 25.0008 6.445 25 7.02V22.9813C25 23.5562 24.8075 24.0367 24.4225 24.4225C24.0375 24.8083 23.5567 25.0008 22.98 25H7.02ZM7.02 23.75H22.9813C23.1729 23.75 23.3492 23.67 23.51 23.51C23.6708 23.35 23.7508 23.1733 23.75 22.98V7.02C23.75 6.8275 23.67 6.65083 23.51 6.49C23.35 6.32917 23.1733 6.24917 22.98 6.25H7.02C6.8275 6.25 6.65083 6.33 6.49 6.49C6.32917 6.65 6.24917 6.82667 6.25 7.02V22.9813C6.25 23.1729 6.33 23.3492 6.49 23.51C6.65 23.6708 6.82625 23.7508 7.01875 23.75M9.375 20.625H20.8175L17.2837 15.9125L14.015 20.0475L11.8275 17.4038L9.375 20.625Z"
                fill="#7E7E7E"
              />
            </svg>
            </div>
            <div className={`${!["Summarized","APPROVED"].includes(card.transcriptionstatus)?"cursor-not-allowed":"cursor-pointer"}`}  onClick={()=>{
                      if(!["Summarized","APPROVED"].includes(card.transcriptionstatus)){
  return
}
setEditCard(card)
handlepdf(card.audiolink.split(".")[0],card)
}}>
            
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.5399 18.2001H6.4999V19.5001H7.5399C7.9299 19.5001 8.1899 19.2401 8.1899 18.8501C8.1899 18.4601 7.9299 18.2001 7.5399 18.2001ZM14.2999 2.6001H3.8999V23.4001H20.7999V9.1001L14.2999 2.6001ZM9.3599 18.9801C9.3599 20.0201 8.5799 20.8001 7.5399 20.8001H6.4999V22.1001H5.1999V16.9001H7.5399C8.5799 16.9001 9.3599 17.6801 9.3599 18.7201V18.9801ZM14.6899 19.6301C14.6899 20.9301 13.6499 22.1001 12.2199 22.1001H10.3999V16.9001H12.2199C13.5199 16.9001 14.6899 17.9401 14.6899 19.3701V19.6301ZM19.4999 18.2001H16.8999V19.5001H18.8499V20.8001H16.8999V22.1001H15.5999V16.9001H19.4999V18.2001ZM19.4999 15.6001H5.1999V3.9001H14.2999V9.1001H19.4999V15.6001ZM12.2199 18.2001H11.6999V20.8001H12.2199C12.9999 20.8001 13.5199 20.2801 13.5199 19.5001C13.5199 18.7201 12.8699 18.2001 12.2199 18.2001Z"
                fill="#7E7E7E"
              />
            </svg> 
            </div> 
           
          </div>
        </div>
        <div className="flex justify-between items-center gap-4 w-full ">
         { renderStatus(card)}
          <div className="inline-flex items-center  w-full gap-3 pl-2 pr-3 py-2 relative bg-lightbackground-secondary rounded-3xl overflow-hidden border-2 border-solid border-[#A1A1A1]  bg-[#F2F3F5]">
  <div className='flex w-full items-center justify-between gap-2'>
  <div className="relative cursor-pointer"  onClick={()=>{


      if(!audioSrc||selectedCard?.audiolink != card?.audiolink ){
        setSelectedCard(card)
        setIsPlaying(false)
        audioRef.current.currentTime = 0;
        handleplay(card.audiolink)
        isallow.current=true
        return
      }
      handlePlayPause()
       
    
      }}>
             <audio
                ref={audioRef}
                src={selectedCard?.audiolink === card.audiolink &&audioSrc}
                onTimeUpdate={handleTimeUpdate}
                onLoadedMetadata={handleLoadedMetadata}
                muted={ismuted}
                onEnded={() => {
                  setIsPlaying(false);

                  audioRef.current.currentTime = 0;
              }}
            />
      <img src={roundmusic} alt="Music Round " />
      <img src={(isPlaying&&selectedCard?.audiolink === card.audiolink )?pause:play} alt="Play" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      
      />
    </div>
    <div className="flex gap-1 justify-center items-center">
  {Array.from({ length: 14 }).map((_, index) => (
    <div
      key={index}
      className={`w-[2px] rounded-[10px]  ${isPlaying && selectedCard?.audiolink === card.audiolink ? 'animate-pulse ' : ''}`}
      style={{
        height: `${(index % 2 === 0 ? 10 : 20)}px`,
        animationDuration: `${0.5 + Math.random()}s`,
        animationDelay: `${Math.random()}s`,
            backgroundColor: 'rgba(126, 126, 126, 1)'
      }}
    />
  ))}
</div>
    <div className="bg-blend-saturation opacity-[0.66] [font-family:'Noto_Sans-Regular',Helvetica] font-normal text-black text-sm tracking-[0] leading-4 whitespace-nowrap">
    {selectedCard?.audiolink === card.audiolink 
    ? `${new Date(currentTime * 1000).toISOString().substr(14, 5)}`
    : "00:00"}
    </div>
    <div onClick={toggleMute}>
    {!ismuted ? <FontAwesomeIcon style={{ color: 'rgba(126, 126, 126, 1)'}} icon={faVolumeHigh} /> : <FontAwesomeIcon style={{ color: 'rgba(126, 126, 126, 1)'}} icon={faVolumeXmark} />}
</div>
  </div>
</div>

        </div>
      </div>
    </>
  );
};

export const Audiocards=({card,handlepdf,setEditCard,setIsEditScreen,setSelectedCard,data,selectedCard,handleplay,searchDate,audioSrc,setAudioSrc,fetchimg})=>{
  const [percentage, setPercentage] = useState(100);
  const circleStyle = {
    background: `conic-gradient(#7E7E7E ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };
  const [showloader,setShowLoader]=useState(false)
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [ismuted,setIsmuted]=useState(false)
  const audioRef = useRef(null);
  const isallow=useRef()
const [isFirsttime,setISfirsttime]=useState(false)
const cardRef=useRef()
const navigate=useNavigate()
   const handlePlayPause = () => {
    if(!audioSrc){
    
      return
    }
    if (isPlaying) {
        audioRef.current.pause();
    } else {
        audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
};
const handleTimeUpdate = () => {
  setCurrentTime(audioRef.current.currentTime);
};

const handleLoadedMetadata = () => {
  setDuration(audioRef.current.duration);
};

const handleSeek = (e) => {
  const newTime = (e.target.value * duration) / 100;
  audioRef.current.currentTime = newTime;
  setCurrentTime(newTime);
};

useEffect(()=>{
if(audioSrc&&!isFirsttime&&isallow.current){
  handlePlayPause()
setISfirsttime(true)
}
},[audioSrc])
useEffect(() => {
  const handleClickOutside = (event) => {
    if (cardRef.current && !cardRef.current.contains(event.target)) {
    isallow.current=false
      setIsPlaying(false);
      if (audioRef.current) {
    
        audioRef.current.currentTime = 0;
      }
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

const toggleMute = () => {
  setIsmuted(!ismuted);
  if (audioRef.current) {
      audioRef.current.muted = !ismuted;
  }
};

const renderStatus = (item) => {
if(item.appointmentid==632498){
  console.log(item,'item')
}
  // Render progress or status based on transcription status
  if (item.transcriptionstatus === null || item.transcriptionstatus === "") {
    return "Ready";
  } else if (item.transcriptionstatus === "Submitted") {
    return <Percentagering percentage={20} />;
  } else if (item.transcriptionstatus === "Processing") {
    const recording_duration = item.recording_duration || 200; // Fallback to a default value
    const totalProcessingTime = Math.max((420 / 1287) * recording_duration, 60);
    const recordingStartTime = DateTime.fromISO(item.ts).toSeconds();
// Current time in UTC, rounded to whole seconds
   const currentTime = Math.floor(DateTime.now().toSeconds()); // or you can use Math.round() if you prefer rounding

    const elapsedSinceStart = Math.max(currentTime - recordingStartTime, 0);

    // Calculate the initial percentage based on the elapsed time
    const completionPercentage = Math.min(
      Math.round(20 + (70 * elapsedSinceStart) / totalProcessingTime),
      90
    );

return <Percentagering percentage={completionPercentage} />;

  } else if (item.transcriptionstatus === "Summarized") {
 
    return (
      <div className="ml-2" onClick={(e)=>{
        e.stopPropagation()
//    setEditCard(card)
// setIsEditScreen(true)
      }}>
        <Tooltip title="Pending Review">
    <Percentagering percentage={100} />
          {/* <PlagiarismIcon className="text-[green]"/> */}
        </Tooltip>
      </div>
    );
  } else if (item.transcriptionstatus === "APPROVED"||item.transcriptionstatus === "SUBMITTED") {
    return (
      <div className="ml-2">
        <Tooltip title="Completed">
          {/* <img src={checkmark} alt="Completed" className="w-6 h-6" /> */}
          <TaskIcon className="text-[green]"/>
        </Tooltip>
      </div>
    );
  } else {
    return null;
  }
}

  return (<> 
   <div
   ref={cardRef}
    className="flex flex-col sm:flex-row justify-between min-h-[38px] items-center w-full  w-full p-[12px] rounded-[12px] border border-[#232323] border-opacity-10 bg-[#FFF]"
  >
   
    <div className="flex flex-col sm:flex-row items-center justify-between w-full sm:w-auto  ">
        
      <div className="flex items-center gap-4  w-[250px]">      
       <AccessTimeIcon className="w-4 h-4" style={{width:'17px'}}/>        
        <div className="text-[#232323] font-inter  text-[16px]  leading-[20px]">
        {formatDdmmyyyy(card?.ts)}
        </div>
      
      </div>
      <div className="flex gap-4 ">
        <div className=" flex items-center">
        { renderStatus(card)}
        </div>
      <div className="inline-flex items-center gap-4 pl-2 pr-3 w-full sm:min-w-[250px]  h-[8vh]  relative bg-lightbackground-secondary rounded-full overflow-hidden border-2 border-solid border-[#A1A1A1]  bg-[#F2F3F5]">
  <div className='flex w-full items-center justify-between gap-4 ' 
 
  >
    <div className="relative cursor-pointer"   onClick={()=>{


      if(!audioSrc||selectedCard?.audiolink != card?.audiolink ){
        setSelectedCard(card)
        setIsPlaying(false)
        audioRef.current.currentTime = 0;
        handleplay(card.audiolink)
        isallow.current=true
        return
      }
      handlePlayPause()
       
    
      }}>
             <audio
                ref={audioRef}
                src={selectedCard?.audiolink === card.audiolink &&audioSrc}
                onTimeUpdate={handleTimeUpdate}
                onLoadedMetadata={handleLoadedMetadata}
                muted={ismuted}
                onEnded={() => {
                  setIsPlaying(false);

                  audioRef.current.currentTime = 0;
              }}
            />
      <img src={roundmusic} alt="Music Round " />
      <img src={(isPlaying&&selectedCard?.audiolink === card.audiolink )?pause:play} alt="Play" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
     
      />
    </div>
    {/* animate-pulse */}
    <div className="flex gap-1 justify-center items-center">
  {Array.from({ length: 16 }).map((_, index) => (
    <div
      key={index}
      
      className={`w-[2px] rounded-[10px]  ${isPlaying && selectedCard?.audiolink === card.audiolink ? 'animate-pulse ' : ''}`}
      style={{
        height: `${(index % 2 === 0 ? 10 : 20)}px`,
        animationDuration: `${0.5 + Math.random()}s`,
        animationDelay: `${Math.random()}s`,
         backgroundColor: 'rgba(126, 126, 126, 1)'
      }}
    />
  ))}
</div>


    <div className="bg-blend-saturation opacity-[0.66] [font-family:'Noto_Sans-Regular',Helvetica] font-normal text-black text-sm tracking-[0] leading-4 whitespace-nowrap">
    {selectedCard?.audiolink === card.audiolink 
    ? `${new Date(currentTime * 1000).toISOString().substr(14, 5)}`
    : "00:00"}

    </div>
    {/* `${new Date(currentTime * 1000).toISOString().substr(14, 5)} / ${new Date(duration * 1000).toISOString().substr(14, 5)}` */}
    <div onClick={toggleMute}>
    {!ismuted ?<FontAwesomeIcon style={{ color: 'rgba(126, 126, 126, 1)'}} icon={faVolumeHigh} /> : <FontAwesomeIcon style={{ color: 'rgba(126, 126, 126, 1)'}} icon={faVolumeXmark} />}
</div>
  </div>
    </div>
</div>
    </div>

    <div className="text-[#1D2951] h-auto mb-4 text-center font-inter text-[13px] font-light mt-4 sm:mt-0 ml-auto flex items-center justify-center gap-4">
      <div className={`${!["Summarized","APPROVED"].includes(card.transcriptionstatus)?"cursor-not-allowed":"cursor-pointer"}`} onClick={()=>{
        if(!["Summarized","APPROVED"].includes(card.transcriptionstatus)){
  return
}
              fetchimg(card.audiolink.split(".")[0],card)    
      }}>
   <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M7.02 25C6.44417 25 5.96375 24.8075 5.57875 24.4225C5.19375 24.0375 5.00083 23.5567 5 22.98V7.02C5 6.44417 5.19292 5.96375 5.57875 5.57875C5.96458 5.19375 6.445 5.00083 7.02 5H22.9813C23.5562 5 24.0367 5.19292 24.4225 5.57875C24.8083 5.96458 25.0008 6.445 25 7.02V22.9813C25 23.5562 24.8075 24.0367 24.4225 24.4225C24.0375 24.8083 23.5567 25.0008 22.98 25H7.02ZM7.02 23.75H22.9813C23.1729 23.75 23.3492 23.67 23.51 23.51C23.6708 23.35 23.7508 23.1733 23.75 22.98V7.02C23.75 6.8275 23.67 6.65083 23.51 6.49C23.35 6.32917 23.1733 6.24917 22.98 6.25H7.02C6.8275 6.25 6.65083 6.33 6.49 6.49C6.32917 6.65 6.24917 6.82667 6.25 7.02V22.9813C6.25 23.1729 6.33 23.3492 6.49 23.51C6.65 23.6708 6.82625 23.7508 7.01875 23.75M9.375 20.625H20.8175L17.2837 15.9125L14.015 20.0475L11.8275 17.4038L9.375 20.625Z"
                fill="#7E7E7E"
              />
            </svg>

      </div>
      <div className={`${card.transcriptionstatus !== "Summarized"?"cursor-not-allowed":"cursor-pointer"}`} onClick={()=>{
                  // navigate(`/archive-edit/${card?.id}/${card?.patient_name}`)
if(card.transcriptionstatus !== "Summarized"){
  return
}

setEditCard(card)
setIsEditScreen(true)
                
      }}>
       <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 27 27"
              fill="none"
            >
              <path
                d="M18.5333 6.08429L20.916 8.46592M20.0655 3.98617L13.6226 10.429C13.2897 10.7615 13.0627 11.185 12.9701 11.6463L12.375 14.6253L15.354 14.029C15.8152 13.9368 16.2382 13.7107 16.5712 13.3777L23.0141 6.93479C23.2077 6.74118 23.3613 6.51134 23.4661 6.25837C23.5709 6.00541 23.6248 5.73429 23.6248 5.46048C23.6248 5.18668 23.5709 4.91555 23.4661 4.66259C23.3613 4.40963 23.2077 4.17978 23.0141 3.98617C22.8205 3.79256 22.5907 3.63898 22.3377 3.5342C22.0847 3.42942 21.8136 3.37549 21.5398 3.37549C21.266 3.37549 20.9949 3.42942 20.7419 3.5342C20.489 3.63898 20.2591 3.79256 20.0655 3.98617V3.98617Z"
                stroke="#7E7E7E"
                stroke-width="2.56214"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21.3755 16.875V20.25C21.3755 20.8467 21.1384 21.419 20.7165 21.841C20.2945 22.2629 19.7222 22.5 19.1255 22.5H6.75049C6.15375 22.5 5.58145 22.2629 5.1595 21.841C4.73754 21.419 4.50049 20.8467 4.50049 20.25V7.875C4.50049 7.27826 4.73754 6.70597 5.1595 6.28401C5.58145 5.86205 6.15375 5.625 6.75049 5.625H10.1255"
                stroke="#7E7E7E"
                stroke-width="2.56214"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

        </div>
 
      
            <div
           className={`${!["Summarized","APPROVED"].includes(card.transcriptionstatus)?"cursor-not-allowed":"cursor-pointer"}`}
            onClick={()=>{
if(!["Summarized","APPROVED"].includes(card.transcriptionstatus)){
  return
}
setEditCard(card)
handlepdf(card.audiolink.split(".")[0],card)
}}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="31"
              height="31"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.5399 18.2001H6.4999V19.5001H7.5399C7.9299 19.5001 8.1899 19.2401 8.1899 18.8501C8.1899 18.4601 7.9299 18.2001 7.5399 18.2001ZM14.2999 2.6001H3.8999V23.4001H20.7999V9.1001L14.2999 2.6001ZM9.3599 18.9801C9.3599 20.0201 8.5799 20.8001 7.5399 20.8001H6.4999V22.1001H5.1999V16.9001H7.5399C8.5799 16.9001 9.3599 17.6801 9.3599 18.7201V18.9801ZM14.6899 19.6301C14.6899 20.9301 13.6499 22.1001 12.2199 22.1001H10.3999V16.9001H12.2199C13.5199 16.9001 14.6899 17.9401 14.6899 19.3701V19.6301ZM19.4999 18.2001H16.8999V19.5001H18.8499V20.8001H16.8999V22.1001H15.5999V16.9001H19.4999V18.2001ZM19.4999 15.6001H5.1999V3.9001H14.2999V9.1001H19.4999V15.6001ZM12.2199 18.2001H11.6999V20.8001H12.2199C12.9999 20.8001 13.5199 20.2801 13.5199 19.5001C13.5199 18.7201 12.8699 18.2001 12.2199 18.2001Z"
                fill="#7E7E7E"
              />
            </svg>
            </div>
    </div>
  </div>
  <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showloader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
  
  </>)
}